import Style from "./Leadership.module.css";

interface LeadershipInfo {
  id: number;
  title: string;
  description: string;
}

interface Props {
  data: LeadershipInfo;
}

const LeaderShip: React.FC<Props> = ({data}) => {
  const {title, description} = data;
  return (
    <div className={Style.leadershipRow}>
      <div className="container">
        <h2>{title}</h2>
        <p>
         {description}
        </p>
      </div>
    </div>
  );
};

export default LeaderShip;
